import React from 'react';

const featuredImages = [
    {
        url: 'https://textbehindimage.com/car.jpg',
        alt: 'Text Behind Image',
    },
    {
        url: 'https://textbehindimage.com/fish.jpg',
        alt: 'AI Background Remover',
    },
    {
        url: 'https://textbehindimage.com/behind.webp',
        alt: 'Viral Post Style',
    },
    {
        url: 'https://textbehindimage.com/sho.jpg',
        alt: 'Creative Design Tool',
    },
];

export default function FeaturedSection() {
    return (
        <section className="relative py-20 overflow-hidden">
            {/* Dotted background with radial mask */}
            <div
                className="absolute inset-0 z-0 opacity-50 [mask-image:radial-gradient(ellipse_80%_50%_at_50%_0%,#000_70%,transparent_110%)]"
                style={{
                    backgroundImage: 'radial-gradient(#cbd5e1 1.5px, transparent 1px)',
                    backgroundSize: '16px 16px',
                }}
            />

            {/* Foreground content */}
            <div className="relative  font-poppins z-10 mx-auto px-4 sm:px-6 lg:px-5 max-w-7xl text-center">
                <p className="text-sm text-left md:text-center font-poppins font-medium text-gray-500 uppercase tracking-wider mb-4 sm:mb-6">
                    Trending Text-Behind-Image Style Posts
                </p>

                <h2 className="text-2xl text-left md:text-center md:px-8 sm:text-4xl md:text-6xl font-poppins font-bold bg-clip-text text-transparent bg-gradient-to-r from-black via-black to-gray-900 mb-8">
                    Create Viral Posts with Stunning Text-Behind Effects & Background-Free Images
                </h2>

                <p className="text-lg text-[#242424] opacity-85 mb-10 font-poppins font-medium">Featured images</p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 justify-center items-stretch">
                    {featuredImages.map((img, i) => (
                        <div
                            key={i}
                            className="relative w-full max-w-md md:max-w-full h-[400px] overflow-hidden rounded-xl group mx-auto"
                        >
                            <img
                                src={img.url}
                                alt={img.alt}
                                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
                                <h3 className="text-white text-left text-lg font-semibold mb-2">{img.alt}</h3>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
